module.exports = __webpack_public_path__ + "img/job-cards.335613ef.png";